import partnerManagement from './PartnerManagementReducer';

export default {
  partnerManagement
};
